"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/no-array-index-key */
const react_1 = __importStar(require("react"));
const emotion_1 = require("emotion");
const Pagination_1 = __importDefault(require("../Pagination"));
const colors_1 = require("../colors");
const SortIndicator_1 = require("./elements/SortIndicator");
const TableBody_1 = require("./elements/TableBody");
const EmptyTableRow_1 = require("./elements/EmptyTableRow");
const Table = (_a) => {
    var { data, columns, sortedBy, noDataText, onSortingRequested, isCondensed, hasHover, isBordered, style, className, pageSize, paginationPosition } = _a, rest = __rest(_a, ["data", "columns", "sortedBy", "noDataText", "onSortingRequested", "isCondensed", "hasHover", "isBordered", "style", "className", "pageSize", "paginationPosition"]);
    const [page, setPage] = react_1.useState(0);
    const onHeaderSortClick = (c) => {
        if (!c.sortable) {
            return;
        }
        if (onSortingRequested) {
            onSortingRequested({
                key: c.accessor,
                desc: (sortedBy && sortedBy.key === c.accessor)
                    ? !sortedBy.desc
                    : (sortedBy ? sortedBy.desc : false),
            });
        }
    };
    const tableStyle = { fontSize: '14px !important', color: colors_1.shale };
    const total = (data || []).length;
    const hasPages = pageSize && (total > pageSize);
    let pagination = null;
    let tableData = data;
    if (hasPages && pageSize) {
        const start = page * pageSize;
        tableData = (data || []).slice(start, start + pageSize);
        pagination = hasPages
            ? (react_1.default.createElement(Pagination_1.default, { initialPage: page, pageCount: Math.ceil(total / pageSize), pageRangeDisplayed: 2, marginPagesDisplayed: 2, onPageChange: ({ selected }) => {
                    setPage(selected);
                } }))
            : null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        paginationPosition === 'topRight'
            ? react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'flex-end' } }, pagination)
            : null,
        react_1.default.createElement("table", Object.assign({ style: Object.assign(Object.assign({}, tableStyle), style), className: emotion_1.cx('table', { 'table-bordered': isBordered }, { 'table-hover': hasHover }, { 'table-condensed': isCondensed }, className) }, rest),
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null, columns.map((c, i) => (react_1.default.createElement("th", { key: `th-${i}-${c.accessor}` }, c.sortable
                    ? (react_1.default.createElement("div", { tabIndex: 0, role: "button", className: c.sortable ? 'clickable' : undefined, style: { textTransform: 'uppercase' }, onClick: () => onHeaderSortClick(c), onKeyDown: event => {
                            if (event.keyCode === 13 || event.keyCode === 32) {
                                event.preventDefault();
                                onHeaderSortClick(c);
                            }
                        } },
                        c.Header,
                        c.sortable
                            ? react_1.default.createElement(SortIndicator_1.SortIndicator, { currentSort: sortedBy, accessor: c.accessor })
                            : null))
                    : c.Header))))),
            react_1.default.createElement("tbody", null, tableData.length > 0
                ? react_1.default.createElement(TableBody_1.TableBody, { data: tableData, columns: columns })
                : react_1.default.createElement(EmptyTableRow_1.EmptyTableRow, { columns: columns, message: noDataText }))),
        paginationPosition === 'bottomRight'
            ? react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'flex-end' } }, pagination)
            : null));
};
exports.default = Table;
